import { WFRoute } from "@xatom/core";
import {
  basicDoctorForm,
  doctorLocatorResult,
} from "../../modules/doctorLocator";
import pricingLanding from "../../modules/pricing";

const publicRoutes = () => {
  // new WFRoute(`/locator`).execute(basicDoctorForm);
  new WFRoute(`/locator`).execute(
    doctorLocatorResult
  );
  new WFRoute(`/patient`).execute(pricingLanding);
};

export default publicRoutes;
